"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
function useLazyQueryHook(query, queryVariables) {
    var _a = (0, client_1.useLazyQuery)(query, {
        variables: queryVariables,
    }), useLazyQueryFunction = _a[0], _b = _a[1], data = _b.data, refetch = _b.refetch, variables = _b.variables, rest = __rest(_b, ["data", "refetch", "variables"]);
    var loading = rest.loading, error = rest.error;
    return {
        useLazyQueryFunction: useLazyQueryFunction,
        loading: loading,
        error: error ? error.message : '',
        data: data,
    };
}
exports.default = useLazyQueryHook;
